import type { Campaign } from 'c-sdk';
import { usesInsertionOrderTargeting } from './insertionOrderTargeting';

/**
 * Does campaign analytics offer the average-audience mode for this campaign? The DSP types whose
 * CAD carries an average audience: `vistar_us`, `vistar_uk` and the insertion-order targeting type
 * (`vistar_us2`, whose average audience also comes from the CAD).
 *
 * Decides the average-audience toggle and whether a stale `?dspAudienceMode=` is cleared from the
 * URL, in `CampaignAnalyticsES(.main).tsx` and `CampaignReports/Views/CampaignAnalyticsTab.tsx`.
 */
export const supportsAverageAudience = (campaign?: Pick<Campaign, 'type'> | null): boolean =>
    campaign?.type === 'vistar_us' ||
    campaign?.type === 'vistar_uk' ||
    usesInsertionOrderTargeting(campaign);
